import { render, staticRenderFns } from "./edit-budget-compensation-modal.vue?vue&type=template&id=6002be4c"
import script from "./edit-budget-compensation-modal.ts?vue&type=script&lang=ts&external"
export * from "./edit-budget-compensation-modal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6002be4c')) {
      api.createRecord('6002be4c', component.options)
    } else {
      api.reload('6002be4c', component.options)
    }
    module.hot.accept("./edit-budget-compensation-modal.vue?vue&type=template&id=6002be4c", function () {
      api.rerender('6002be4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/in-year-budget-requests/view-in-year-budget-request/edit-budget-compensation-modal/edit-budget-compensation-modal.vue"
export default component.exports